import Vue from 'vue'
import Router from 'vue-router' 
import store from '@/store'
import { auth } from '@/firebase/db'

/* layouts */
import loginLayout from '@/layouts/login/index'
import standardLayout from '@/layouts/standard/index'

/* routes */
import dashboard from '@/pages/dashboard'
import login from '@/pages/login'
import projects from '@/pages/projects'
import projectAdd from '@/pages/projectAdd'
import employees from '@/pages/employees'
import employeeAdd from '@/pages/employeeAdd'
import projectDetails from '@/pages/projectDetails'
import employee from '@/pages/employee'
import companies from '@/pages/companies'
import companyDetails from '@/pages/companyDetails'
import companiesNew from '@/pages/companiesNew'
import projectUsersEdit from '@/pages/projectUsersEdit'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: dashboard,
      meta: { layout: standardLayout }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: { layout: loginLayout }
    },
    
    /* Employees */
    {
      path: '/employees',
      name: 'employees',
      component: employees,
      meta: { layout: standardLayout }
    },
    {
      path: '/employee/:id',
      name: 'employee',
      component: employee,
      meta: { layout: standardLayout }
    },
    {
      path: '/employeeAdd',
      name: 'employeeAdd',
      component: employeeAdd,
      meta: { layout: standardLayout }
    },

    /* Projects */
    {
      path: '/projects',
      name: 'projects',
      component: projects,
      meta: { layout: standardLayout }
    },
    {
      path: '/project/:id',
      name: 'project',
      component: projectDetails,
      meta: { layout: standardLayout }
    },
    
    {
      path: '/projectAdd',
      name: 'projectAdd',
      component: projectAdd,
      meta: { layout: standardLayout }
    },
    {
      path: '/projectUsersEdit/:id',
      name: 'projectUsersEdit',
      component: projectUsersEdit,
      meta: { layout: standardLayout }
    },
    
    

    /* Companies */
    {
      path: '/companies',
      name: 'companies',
      component: companies,
      meta: { layout: standardLayout }
    },
    {
      path: '/company/:id',
      name: 'company',
      component: companyDetails,
      meta: { layout: standardLayout }
    },
    {
      path: '/addCompany',
      name: 'companyNew',
      component: companiesNew,
      meta: { layout: standardLayout }
    }
  ]
})

function isAuthenticated(){
  return (auth.currentUser != null || store.getters['user/get'])
}

router.beforeEach((to, from, next) => {
  if (to.name !== 'login' && !isAuthenticated()) next({ path: '/login' })
  else next()
})

export default router
